// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S_mX","label":"styles_label__1UsXy"};